import { addLogDebug, addLogError } from "./logger"
import { clearCaches } from "../components/UpdateNotification"

export function reloadApp() {
  addLogDebug("reload application")

  setTimeout(() => {
    // A failed cache clear must not stop the reload
    clearCaches()
      .catch((error) => addLogError("reloadApp: clearing caches failed", error))
      .finally(() => window.location.reload())
  }, 1000)
}
